import React from 'react';
import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';

import backgroundLg from './pageBannerLarge.png';
import backgroundMd from './pageBannerMedium.png';
import backgroundSm from './pageBannerSmall.png';

const PageBannerContainer = styled.div`
    background: #8c5bba url(${backgroundSm}) right center no-repeat;
    background-size: contain;
    color: ${COLORS.white};
    box-sizing: border-box;
    height: auto;
    width: 100%;

    @media only screen and (max-width: 1359px) {
        background-image: url(${backgroundLg});
    }

    @media only screen and (max-width: 1023px) {
        background-image: url(${backgroundMd});
    }

    @media screen and (max-width: 859px) {
        margin-top: 50px;
    }

    @media only screen and (max-width: 767px) {
        background-image: none;
    }
`;

const PageBannerWrapper = styled.div`
    box-sizing: border-box;
    align-items: center;
    display: flex;
    padding: 0 7%;
    margin: 0 auto;
    max-width: 1440px;
    width: 100%;

    @media screen and (max-width: 859px) {
        padding: 0 15px;
        width: 100%;
    }
`;

const PageBannerTitle = styled.h1`
    font: 300 64px/72px 'robotoLight', sans-serif;

    @media only screen and (max-width: 1359px) {
        font-size: 44px;
        line-height: 48px;
    }

    @media only screen and (max-width: 375px) {
        font-size: 38px;
        line-height: 42px;
    }
`;

export default function PageBanner({ city }) {
    let title;
    if (city === undefined) {
        title = <PageBannerTitle>Телепрограмма</PageBannerTitle>;
    } else if (city.length > 7) {
        title = <PageBannerTitle>Телепрограмма<br/>в {city}</PageBannerTitle>;
    } else {
        title = <PageBannerTitle>Телепрограмма в {city}</PageBannerTitle>;
    }

    return (
        <PageBannerContainer>
            <PageBannerWrapper>
            {title}
            </PageBannerWrapper>
        </PageBannerContainer>
    );
}
